import pageImage from "AdvisoryManagement/Assets/Images/InvesticniDotaznik.png";

export const InvestmentQuestionnairePage = () => {
	return (
		<img
			src={pageImage}
			alt="ELIS"
			style={{ maxWidth: "100%", height: "auto" }}
		/>
	);
};
